export const DropDownSettings = {
    CommonDropdownSettings: {
        singleSelection: false,
        idField: "id",
        textField: "name",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    ServiceDropdownSettings: {
        singleSelection: false,
        idField: "serviceTypeId",
        textField: "serviceTypeName",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    StatusDropdownSettings: {
        singleSelection: false,
        idField: "statusId",
        textField: "statusName",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    CustomerDropdownSettings: {
        singleSelection: false,
        idField: "customerID",
        textField: "customerName",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    TissueIdDropdown: {
        singleSelection: false,
        idField: "serviceRequestId",
        textField: "tissueId",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    LocationDropdownSettings: {
        singleSelection: false,
        idField: "id",
        textField: "name",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    RegionDropdownSettings: {
        singleSelection: false,
        idField: "id",
        textField: "name",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    FinancialStatusSettings: {
        singleSelection: false,
        idField: "financeStatusId",
        textField: "financeStatusName",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    MemberDropdownSettings: {
        singleSelection: false,
        idField: "memberId",
        textField: "memberName",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    CoordinatorDropdownSettings: {
        singleSelection: false,
        idField: "memberID",
        textField: "memberName",
        itemsShowLimit: 1,
        allowSearchFilter: true,
    },
    TimeZoneConfig: {
        displayKey: "shortName",
        search: true,
        placeholder: 'Select Timezone',
        height: "170px"
    }
}
